import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";

const AddInventory = () => {
  const [inventory, setInventory] = useState([]); // All records
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [supervisorNames, setSupervisorNames] = useState([]); // Supervisor names for dropdown
  const [nokeData, setNokeData] = useState([]); // NOKE data
  const [formData, setFormData] = useState({
    LOT_ID: "",
    // jobOrderDate: "",
    supervisor: "",
    LOCATION: "",
    status: "",
  }); // Form data for add/update
  const [isEditing, setIsEditing] = useState(false); // Toggle between add and edit
  const [editingId, setEditingId] = useState(null); // ID for the record being edited
  const [showModal, setShowModal] = useState(false); // Modal state
  const [activeStockRow, setActiveStockRow] = useState(null);
  const [stockData, setStockData] = useState({});

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const [expandedIndex, setExpandedIndex] = useState(null);
  const [dviData, setDviData] = useState({});
  //
  const handleJobOrderClick = async (joNo, index) => {
    // Toggle
    if (expandedIndex === index) {
      setExpandedIndex(null);
      return;
    }

    try {
      const response = await axiosInstance.get(
        `/api/dvi-data/${encodeURIComponent(joNo)}`
      );
      setDviData((prev) => ({
        ...prev,
        [joNo]: response.data,
      }));
      setExpandedIndex(index);
    } catch (error) {
      console.error("Failed to fetch DVI data:", error);
    }
  };
  //run-item-stock
  const handleSelectItem = async (
    itemName,
    quantity,
    parentIndex,
    dviIndex
  ) => {
    try {
      const response = await axiosInstance.post("/api/run-item-stock", {
        itemName,
        quantity,
      });

      const result = response.data;

      if (result.length === 0) {
        alert("No stock records found.");
        return;
      }

      const key = `${parentIndex}-${dviIndex}`;
      if (activeStockRow === key) {
        setActiveStockRow(null);
        return;
      }
      setActiveStockRow(key); // 👈 This enables conditional rendering of stock table
      setStockData((prev) => ({
        ...prev,
        [key]: result,
      }));
    } catch (error) {
      console.error("Stored procedure failed:", error);
      alert("⚠️ Failed to get stock info.");
    }
  };
  // Handle Admin and  Sync Store data

  // Fetch all inventory records
  const fetchInventory = async () => {
    try {
      const response = await axiosInstance.get("/api/noke-inventory");
      setInventory(response.data);
    } catch (error) {
      console.error("Error fetching inventory:", error);
      //   alert("Failed to fetch inventory records.");
    }
  };

  // Fetch NOKE data
  const fetchNokeData = async () => {
    try {
      const response = await axiosInstance.get("/api/noke-data");
      setNokeData(response.data);
    } catch (error) {
      console.error("Error fetching NOKE data:", error);
    }
  };

  // Fetch supervisor names
  const fetchSupervisorNames = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/AllSupervisorName");
      setSupervisorNames(response.data);
    } catch (error) {
      console.error("Error fetching supervisor names:", error);
      alert("Failed to fetch supervisor names.");
    }
  }, []);

  useEffect(() => {
    fetchInventory();
    fetchSupervisorNames();
    fetchNokeData();
  }, [fetchSupervisorNames]);

  // Handle input changes in the form
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission for add/update
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEditing) {
        // Update record
        await axiosInstance.patch(`/api/noke-inventory/${editingId}`, formData);
        alert("Record updated successfully!");
      } else {
        // Add new record
        await axiosInstance.post("/api/noke-inventory", formData);
        alert("Record added successfully!");
      }

      setShowModal(false);
      setFormData({
        LOT_ID: "",
        // jobOrderDate: "",
        supervisor: "",
        LOCATION: "",
        status: "Not Use",
      });
      setIsEditing(false);
      fetchInventory();
    } catch (error) {
      // // Check for duplicate LOT_ID error
      // if (error.response && error.response.status === 400 && error.response.data.error === "This LOT ID is already issued.") {
      //   alert("This LOT ID is already issued.");
      // } else {
      console.error("Error submitting form:", error);
      alert("Failed to submit form.");
    }
  };

  // Handle delete action
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axiosInstance.delete(`/api/noke-inventory/${id}`);
      alert("Record deleted successfully!");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting record:", error);
      alert("Failed to delete record.");
    }
  };

  // Open modal for editing
  const handleEdit = (record) => {
    setFormData({
      LOT_ID: record["LOT_ID"],
      // jobOrderDate: record["JOB ORDER DATE"],
      supervisor: record["SUPERVISOR"],
      LOCATION: record["LOCATION"],
      //   status: record["STATUS"],
    });
    setEditingId(record.ID);
    setIsEditing(true);
    setShowModal(true);
  };

  // Open modal for adding
  const handleAdd = () => {
    setFormData({
      LOT_ID: "",
      // jobOrderDate: "",
      supervisor: "",
      LOCATION: "",
      status: "Not Use",
    });
    setIsEditing(false);
    setShowModal(true);
  };

  // DataTable columns
  const columns = [
    {
      name: "LOT ID",
      selector: (row) => row["LOT_ID"],
      sortable: true,
    },
    // {
    //   name: "DATE",
    //   selector: (row) => row["DATE"],
    //   sortable: true,
    // },
    {
      name: "DATE",
      selector: (row) =>
        new Date(row["DATE"]).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }), // Format: DD/MM/YYYY
      sortable: true,
    },

    {
      name: "SUPERVISOR",
      selector: (row) => row["SUPERVISOR"],
      sortable: true,
    },
    {
      name: "LOCATION",
      selector: (row) => row["LOCATION"],
      sortable: true,
    },
    {
      name: "STATUS",
      selector: (row) => row["STATUS"],
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <button
            className="btn btn-primary btn-sm me-2"
            onClick={() => handleEdit(row)}
          >
            Edit
          </button>
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(row.ID)}
          >
            Delete
          </button>
        </>
      ),
    },
  ];

  return (
    <div className="d-flex dashboard">
      <div
        className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}
      >
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />
        <main
          className="main-container p-4"
          style={{ height: "-webkit-fill-available" }}
        >
          <div className="container table-responsive ">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>JOB ORDER NO</th>
                  <th>JOB ORDER DATE</th>
                  <th>ITEM NAME</th>
                  <th>PROCESS NAME</th>
                  <th>QUANTITY</th>
                  <th>DEPARTMENT</th>
                </tr>
              </thead>
              <tbody>
                {nokeData.length > 0 ? (
                  nokeData.map((item, index) => (
                    <React.Fragment key={index}>
                      {/* Main Row */}
                      <tr>
                        <td
                          onClick={() =>
                            handleJobOrderClick(item["JOB ORDER NO"], index)
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight: "bold",
                            color: "#0d6efd",
                          }}
                        >
                          {item["JOB ORDER NO"] || "N/A"}
                        </td>
                        <td>
                          {item["JOB ORDER DATE"]
                            ? new Date(
                                item["JOB ORDER DATE"]
                              ).toLocaleDateString("en-GB")
                            : "N/A"}
                        </td>
                        <td>{item["ITEM NAME"] || "N/A"}</td>
                        <td>{item["PROCESS NAME"] || "N/A"}</td>
                        <td>{item["QUANTITY"] || "N/A"}</td>
                        <td>{item["DEPARTMENT"] || "N/A"}</td>
                      </tr>

                      {/* Dropdown Row */}
                      {expandedIndex === index && (
                        <tr>
                          <td
                            colSpan="6"
                            style={{ backgroundColor: "#f8f9fa" }}
                          >
                            {dviData[item["JOB ORDER NO"]] &&
                            dviData[item["JOB ORDER NO"]].length > 0 ? (
                              <table className="table table-sm table-bordered mb-0">
                                <thead className="table-secondary">
                                  <tr>
                                    <th>RM ITEM NAME</th>
                                    <th>QTY REQ</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dviData[item["JOB ORDER NO"]].map(
                                    (dviItem, dviIndex) => {
                                      const key = `${index}-${dviIndex}`;
                                      const showStock = activeStockRow === key;
                                      return (
                                        <React.Fragment key={dviIndex}>
                                          <tr>
                                            <td>
                                              {dviItem[
                                                "RM_ITEM_NAME_WO_SHADE"
                                              ] || "N/A"}
                                            </td>
                                            <td>
                                              {dviItem["QTY_REQ"] || "N/A"}
                                            </td>
                                            <td>
                                              <button
                                                className="btn btn-sm btn-primary"
                                                onClick={() =>
                                                  handleSelectItem(
                                                    dviItem[
                                                      "RM_ITEM_NAME_WO_SHADE"
                                                    ],
                                                    dviItem["QTY_REQ"],
                                                    index,
                                                    dviIndex
                                                  )
                                                }
                                              >
                                                Select
                                              </button>
                                            </td>
                                          </tr>

                                          {/* Nested Table for Stock */}
                                          {/* {showStock && stockData[key] && (
                                            <tr>
                                              <td colSpan="3">
                                                <table className="table table-bordered table-striped table-sm mb-0">
                                                  <thead className="table-light">
                                                    <tr>
                                                      <th>ITEM NAME</th>
                                                      <th>BARCODE</th>
                                                      <th>DESCRIPTION</th>
                                                      <th>LOT NO</th>
                                                      <th>PURCHASE DATE</th>
                                                      <th>CLOSING STOCK</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {stockData[key].map(
                                                      (
                                                        stockItem,
                                                        stockIndex
                                                      ) => (
                                                        <tr key={stockIndex}>
                                                          <td>
                                                            {
                                                              stockItem[
                                                                "ITEM NAME"
                                                              ]
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              stockItem[
                                                                "BARCODE"
                                                              ]
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              stockItem[
                                                                "ITEM DESCRIPTION"
                                                              ]
                                                            }
                                                          </td>
                                                          <td>
                                                            {
                                                              stockItem[
                                                                "LOT NUMBER"
                                                              ]
                                                            }
                                                          </td>
                                                          <td>
                                                            {stockItem[
                                                              "PURCHASE DATE"
                                                            ]
                                                              ? new Date(
                                                                  stockItem[
                                                                    "PURCHASE DATE"
                                                                  ]
                                                                ).toLocaleDateString(
                                                                  "en-GB"
                                                                )
                                                              : "N/A"}
                                                          </td>
                                                          <td>
                                                            {
                                                              stockItem[
                                                                "TOTAL CLOSING STOCK"
                                                              ]
                                                            }
                                                          </td>
                                                        </tr>
                                                      )
                                                    )}
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          )} */}
                                 {showStock && stockData[key] && (
  <tr>
    <td colSpan="6">
      <table className="table table-bordered table-striped table-sm mb-0">
        <thead className="table-light">
          <tr>
            <th>ITEM NAME</th>
            <th>BARCODE</th>
            <th>DESCRIPTION</th>
            <th>LOT NO</th>
            <th>PURCHASE DATE</th>
            <th>CLOSING STOCK</th>
            <th>Action</th> {/* 👈 Added Action column header */}
          </tr>
        </thead>
        <tbody>
          {stockData[key].map((stockItem, stockIndex) => (
            <tr key={stockIndex}>
              <td>{stockItem["ITEM NAME"]}</td>
              <td>{stockItem["BARCODE"]}</td>
              <td>{stockItem["ITEM DESCRIPTION"]}</td>
              <td>{stockItem["LOT NUMBER"]}</td>
              <td>
                {stockItem["PURCHASE DATE"]
                  ? new Date(stockItem["PURCHASE DATE"]).toLocaleDateString("en-GB")
                  : "N/A"}
              </td>
              <td>{stockItem["TOTAL CLOSING STOCK"]}</td>
              <td>
                <a
                  href={`/manual-rm-issue?rmItemName=${encodeURIComponent(
                    stockItem["ITEM NAME"]
                  )}&barcode=${encodeURIComponent(
                    stockItem["BARCODE"]
                  )}&lotNumber=${encodeURIComponent(
                    stockItem["LOT NUMBER"]
                  )}&lotId=${encodeURIComponent(item["ITEM NAME"])}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-warning btn-sm"
                >
                   RM Issue Form
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </td>
  </tr>
)}

                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            ) : (
                              <div className="text-muted">
                                No DVI data found for this Job Order.
                              </div>
                            )}
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end mb-3">
            <button
              className="btn btn-outline-success mb-3"
              onClick={handleAdd}
            >
              Add New Record
            </button>
          </div>
          <DataTable columns={columns} data={inventory} pagination />
        </main>
      </div>
      {/* Modal for Add/Edit */}
      {showModal && (
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditing ? "Edit Record" : "Add Record"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">LOT ID</label>
                    <input
                      type="text"
                      name="LOT_ID"
                      value={formData.LOT_ID}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                      placeholder="Enter LOT ID"
                    />
                  </div>
                  {/* <div className="mb-3">
                    <label className="form-label">Job Order Date</label>
                    <input
                      type="date"
                      name="jobOrderDate"
                      value={formData.jobOrderDate}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div> */}
                  <div className="mb-3">
                    <label className="form-label">Supervisor Name</label>
                    <select
                      name="supervisor"
                      value={formData.supervisor}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Supervisor</option>
                      {supervisorNames.map((supervisor, index) => (
                        <option key={index} value={supervisor.SupervisorName}>
                          {supervisor.SupervisorName}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div className="mb-3">
                    <label className="form-label">Location</label>
                    <input
                      type="text"
                      name="LOCATION"
                      value={formData.LOCATION}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div> */}
                  <div className="mb-3">
                    <label className="form-label">Location</label>
                    <select
                      name="LOCATION"
                      value={formData.LOCATION}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Location</option>
                      <option value="BKB 7">BKB 7</option>
                      <option value="BKB 8">BKB 8</option>
                      <option value="BKB 9">BKB 9</option>
                      <option value="BKB 10">BKB 10</option>
                      <option value="BKB 11">BKB 11</option>
                      <option value="BKB 12">BKB 12</option>
                      <option value="BKB 13">BKB 13</option>
                      <option value="BKB 14">BKB 14</option>
                      <option value="BKB 15">BKB 15</option>
                      <option value="BKB 16">BKB 16</option>
                      <option value="BKB 17">BKB 17</option>
                      <option value="BKB 18">BKB 18</option>
                    </select>
                  </div>
                  {/* Hide status field when editing */}
                  {!isEditing && (
                    <div className="mb-3" style={{ display: "none" }}>
                      <label className="form-label">Status</label>
                      <input
                        type="text"
                        name="status"
                        value={formData.status}
                        onChange={handleInputChange}
                        className="form-control"
                        required
                        readOnly
                      />
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">
                    {isEditing ? "Update" : "Add"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddInventory;
